
export enum CategoryType {
    PRODUCT = 1,
    ARTICLE = 2,
}
